import { InputHTMLAttributes } from "react";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    label?: string | undefined;
    className?: string | undefined;
    type?: string | undefined;
    accept?: string | undefined;
    alt?: string | undefined;
    disabled?: boolean | undefined;
    name?: string | undefined;
    placeholder?: string | undefined;
    required?: boolean | undefined;
    id?: string | undefined;
    ref?: any;
    labelClass?: any;
    key?: string | number | undefined;
}

const Input = ({label, id, ...props }: Props) => {

  const extraClass = props.labelClass ??  "mb-2 xl:text-[23px] text-[20px] text-dark02";

  return (
    <div className="flex flex-col mt-4">
      <label htmlFor={id} className={extraClass}>{label}</label>
      <input {...props} />
    </div>
);
};

export default Input;
